module.exports = __webpack_public_path__ + "img/env_icon2.491f3ec4.png";